export const sectionLayoutByVariant = {
  desktop: {
    compass: {
      bottom: 0,
      left: 60,
      width: 260,
    },
    direction: 'row',
    py: 76,
    tape: {
      left: 2,
      top: 40,
    },
  },
  laptop: {
    compass: {
      bottom: 17,
      left: -81,
      width: 200,
    },
    direction: 'row',
    py: 121,
    tape: {
      left: -72,
      top: 36,
    },
  },
  mobile: {
    compass: {
      bottom: 0,
      left: -52,
      width: 150,
    },
    direction: 'column',
    py: 80,
    tape: {
      left: -72,
      top: 0,
    },
  },
  tablet: {
    compass: {
      bottom: 17,
      left: -81,
      width: 200,
    },
    direction: 'column',
    py: 80,
    tape: {
      left: -72,
      top: 10,
    },
  },
};
